import client from './client';

export async function status()  { const { data } = await client.get('/api/odoo/status');  return data; }
export async function preview() { const { data } = await client.post('/api/odoo/preview'); return data; }
export async function sync()    { const { data } = await client.post('/api/odoo/sync');    return data; }
export async function setAutoSync(enabled) { const { data } = await client.put('/api/odoo/settings', { autoSyncEnabled: enabled }); return data; }
